export function intersectionExists(haystack, arr) {
  return arr.some((value) => {
    return haystack.indexOf(value) >= 0;
  });
}
